import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";

export default function NoAccess({ title = "Todavía no tienes acceso a ningún proyecto", backTo }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-xl mx-auto px-4 sm:px-6 py-24 text-center" data-testid="no-access-page">
        <div className="mx-auto h-14 w-14 rounded-2xl bg-accent text-olive flex items-center justify-center mb-6">
          <Lock className="h-6 w-6" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Pide al administrador del proyecto que te añada como Cliente o Colaborador con el email{" "}
          <span className="font-mono text-foreground">{user?.email}</span>. En cuanto lo haga, podrás entrar desde tu portal.
        </p>
        {backTo && (
          <Button asChild variant="outline" className="rounded-full mt-8">
            <Link to={backTo} data-testid="no-access-back-link">Volver</Link>
          </Button>
        )}
      </main>
    </div>
  );
}
